import { amountToString } from "./tool";

export function formateProducts(list = []) {
  return list.reduce((preSeller, seller) => {
    const sellerId = seller.supplier_id;
    const sellerName = seller.supplier_name;
    const productList = seller.sale_list;
    // const productList1 = [...seller.sale_list, ...seller.sale_list, ...seller.sale_list, ...seller.sale_list];
    // const productList = productList1.map((item, index) => ({ ...item, sale_id: index + 10, norms_id: index + 1, cart_id: index + 20, is_mapping: 0, is_unified: index !== 3,current: index ===0 }));
    const isRelation = seller.is_relation;
    const currentProducts = productList.map(product => ({
      ...product,
      cartId: +(product.cart_id),
      normsId: +(product.norms_id),
      id: +(product.sale_id),
      num: product.number,
      isRelation,
      sellerId,
      sellerName,
      unit_amount: amountToString(product.unit_amount),
      subtotal: amountToString(product.subtotal),
      is_on_sale: product.is_on_sale === 1 ? 1 : 0,
      unit: product.sku_unit
    }));
    return [...preSeller, ...currentProducts];
  }, []);
}

export function modifyProductNum(state, updateProducts = [], init) {
  const { products = [], ids = [], cartIds = [], sellers = [], sellerIds = [], } = state;
  let newSellerIds = [...sellerIds];
  let newIds = [...ids];
  let newCartIds = [...cartIds];
  let newSellers = Object.assign({}, sellers);
  let newProducts = Object.assign({}, products);

  if (init) {
    newSellerIds = [];
    newIds = [];
    newCartIds = [];
    newSellers = [];
    newProducts = [];
  }
  updateProducts.forEach((product) => {
    const { num, normsId, sellerId, sellerName, cartId, is_unified = false } = product;
    if (num > 0) {
      if (!newSellers[sellerId]) {
        newSellers[sellerId] = {
          id: sellerId,
          name: sellerName,
          productIds: [],
        };
        newSellerIds.push(sellerId);
      }
      if (!newProducts[normsId]) {
        newProducts[normsId] = Object.assign({}, product, { num });
        is_unified && newIds.push(normsId);
        is_unified && newCartIds.push(cartId);
        newSellers[sellerId].productIds.push(normsId);
      } else {
        newProducts[normsId] = Object.assign({}, newProducts[normsId], { num });
      }
    }
  });
  return {
    products: newProducts,
    ids: newIds,
    cartIds: newCartIds,
    sellers: newSellers,
    sellerIds: newSellerIds,
  };
}


export function mapState(state) {
  let { sellers, products, ids } = state;
  const shopList = Object.values(sellers).map(seller => {
    const { id: supplierId, name: supplierName } = seller;
    let isRelation = false;
    const saleList = (seller.productIds || []).map(item => {
      const currentProducts = products[item];
      isRelation = currentProducts.isRelation;
      return currentProducts;
    }) || [];
    return { supplierId, supplierName, saleList, isRelation };
  });

  return { shopList, ids, products };
};

export function planFormateProducts(list = []) {
  return list.reduce((preSeller, seller = {}) => {
    const { supplier_id: sellerId, supplier_name: sellerName, sale_list: productList = [], address: addressInfo = {}, submit_id, other_cost = [] } = seller;
    const { id: addressId, province_name, city_name, area_name, address } = addressInfo;
    const addressDetail = province_name + city_name + area_name + address || null;
    const isRelation = seller.is_relation;
    const currentProducts = productList.map(product => ({
      ...product,
      cartId: +(product.cart_id),
      normsId: product.norms_id,
      id: +(product.sale_id),
      num: product.number,
      isRelation,
      sellerId,
      sellerName,
      unit_amount: amountToString(product.unit_amount),
      subtotal: amountToString(product.subtotal),
      is_on_sale: product.is_on_sale === 1 ? 1 : 0,
      unit: product.sku_unit,
      addressId,
      addressDetail,
      other_cost,
      submit_id
    }));
    return [...preSeller, ...currentProducts];
  }, []);
}

export function planModifyProductNum(state, updateProducts = [], init) {
  const { products = [], ids = [], cartIds = [], sellers = [], sellerIds = [], } = state;
  let newSellerIds = [...sellerIds];
  let newIds = [...ids];
  let newCartIds = [...cartIds];
  let newSellers = Object.assign({}, sellers);
  let newProducts = Object.assign({}, products);

  if (init) {
    newSellerIds = [];
    newIds = [];
    newCartIds = [];
    newSellers = [];
    newProducts = [];
  }
  updateProducts.forEach((product) => {
    const { num, normsId, sellerId, sellerName, cartId, qoute_id = false, addressId, addressDetail, other_cost = [], submit_id } = product;
    const uniqueKey = `${sellerId}-${addressId}`;
    if (num > 0) {
      if (!newSellers[uniqueKey]) {
        newSellers[uniqueKey] = {
          id: uniqueKey,
          name: sellerName,
          productIds: [],
          addressDetail,
          addressId,
          other_cost,
          submit_id
        };
        newSellerIds.push(uniqueKey);
      }
      if (!newProducts[normsId]) {
        newProducts[normsId] = Object.assign({}, product, { num });
        qoute_id && newIds.push(normsId);
        qoute_id && newCartIds.push(cartId);
        newSellers[uniqueKey].productIds.push(normsId);
      } else {
        newProducts[normsId] = Object.assign({}, newProducts[normsId], { num });
      }
    }
  });
  return {
    products: newProducts,
    ids: newIds,
    cartIds: newCartIds,
    sellers: newSellers,
    sellerIds: newSellerIds,
  };
}


export function planMapState(state) {
  let { sellers, products, ids } = state;
  const shopList = Object.values(sellers).map(seller => {
    const { id: supplierId, name: supplierName, addressDetail, addressId, other_cost, submit_id } = seller;
    let isRelation = false;
    const saleList = (seller.productIds || []).map(item => {
      const currentProducts = products[item];
      isRelation = currentProducts.isRelation;
      return currentProducts;
    }) || [];
    return { supplierId, supplierName, saleList, isRelation, addressDetail, addressId, other_cost, submit_id };
  });

  return { shopList, ids, products };
};